import axios from "axios";
import { BASE_URL } from "../constants";
import { setupResponseInterceptors } from "./interceptors";

const getLanguageHeader = () => localStorage.getItem("language") || "en";

export const axiosAuth = axios.create({
  baseURL: BASE_URL,
  timeout: 10000,
  headers: { Accept: "application/json" },
  withCredentials: true,
});

axiosAuth.interceptors.request.use(
  (config) => {
    const accessToken = localStorage.getItem("access_token");
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    config.headers["Accept-Language"] = getLanguageHeader();
    return config;
  },
  (error) => Promise.reject(error)
);

setupResponseInterceptors(axiosAuth);
